import React from 'react';
import { Zap, Lock, Shield } from 'lucide-react';
export function TopBar() {
  return <div className="sticky top-0 z-50 bg-black/95 backdrop-blur-md border-b border-primary/20 text-white" data-id="element-445">
      <div className="bg-primary text-black py-1.5 px-3 text-center font-space-grotesk font-bold text-[10px] sm:text-xs md:text-sm" data-id="element-446">
        🇦🇷 El método N°1 de glúteos para mujeres argentinas — 4 Tomos + Bono
        Recetario
      </div>
      <div className="hidden md:flex items-center justify-center gap-6 py-2 px-3 text-xs text-zinc-300" data-id="element-447">
        <span className="flex items-center gap-1.5" data-id="element-448">
          <Zap className="w-3.5 h-3.5 text-primary" data-id="element-449" /> Acceso en 5 minutos
        </span>
        <span className="text-zinc-700" data-id="element-450">·</span>
        <span className="flex items-center gap-1.5" data-id="element-451">
          <Lock className="w-3.5 h-3.5 text-primary" data-id="element-452" /> Pago seguro
        </span>
        <span className="text-zinc-700" data-id="element-453">·</span>
        <span className="flex items-center gap-1.5" data-id="element-454">
          <Shield className="w-3.5 h-3.5 text-primary" data-id="element-455" /> Garantía de 7 días
        </span>
      </div>
    </div>;
}